import React, { useMemo } from "react";

const SPARK_COLORS = ["#FF007F", "#00F0FF", "#FFE600", "#FF9500", "#B44DFF"];

export function TrainingAmbient() {
  const sparks = useMemo(() => Array.from({ length: 34 }, (_, i) => ({
    i, x: Math.random() * 100, s: 2 + Math.random() * 3.5, c: SPARK_COLORS[i % SPARK_COLORS.length],
    d: -Math.random() * 14, t: 9 + Math.random() * 9, sx: `${(Math.random() - 0.5) * 160}px`,
  })), []);
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid="training-ambient">
      <div className="tr-haze absolute -top-[20%] -left-[10%] w-[60vw] h-[60vw] rounded-full blur-3xl" style={{ background: "radial-gradient(circle, rgba(255,0,127,0.26), transparent 62%)" }} />
      <div className="tr-haze absolute top-[25%] -right-[15%] w-[55vw] h-[55vw] rounded-full blur-3xl" style={{ background: "radial-gradient(circle, rgba(0,240,255,0.2), transparent 62%)", animationDelay: "-7s", animationDuration: "22s" }} />
      <div className="tr-haze absolute -bottom-[30%] left-[25%] w-[50vw] h-[50vw] rounded-full blur-3xl" style={{ background: "radial-gradient(circle, rgba(157,0,255,0.24), transparent 62%)", animationDelay: "-13s", animationDuration: "26s" }} />
      {sparks.map((p) => (
        <span key={p.i} className="tr-spark absolute bottom-[-12px] rounded-full"
              style={{ left: `${p.x}%`, width: p.s, height: p.s, background: p.c, boxShadow: `0 0 ${p.s * 3}px ${p.c}`,
                       animationDelay: `${p.d}s`, animationDuration: `${p.t}s`, "--sx": p.sx }} />
      ))}
      <div className="wr-grain absolute inset-0" />
    </div>
  );
}

export function StageRow({ label, color, picker, action, align = "left" }) {
  const right = align === "right";
  return (
    <div className={`flex items-center justify-between gap-2 rounded-xl px-3 py-2 border-2 bg-[#0A051A]/80 transition-[box-shadow] duration-200 hover:shadow-[0_0_16px_var(--sr-glow)] ${right ? "flex-row-reverse text-right" : ""}`}
         style={{ borderColor: `${color}55`, "--sr-glow": `${color}55` }}>
      <div className="min-w-0">
        <div className="text-[9px] font-mono uppercase tracking-widest text-[#A89BCC] leading-tight">{label}</div>
        {picker}
      </div>
      {action}
    </div>
  );
}
